import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import TpPlatformInvoiceService from '../../../Services/TpPlatformInvoiceService';
import TpPlatformInvoiceBillingPeriodOverrideItem from '../../../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceBillingPeriodOverrideItem';

class SetBillingPeriodWindowDescription extends React.Component {
  static titleForEdit = 'Set Billing Period';
  static ComponentName = 'SetBillingPeriod';
  static itemType = TpPlatformInvoiceBillingPeriodOverrideItem;
  static messageOnSuccess = 'The billing period override has been saved.';
  // The wizard surfaces backend TpException messages only when the call is RETURNED.
  static serviceFunction = (edited) =>
    TpPlatformInvoiceService.SetBillingPeriodOverride({
      ThirdPartySource: edited.ThirdPartySource,
      ThirdPartyInvoiceId: edited.ThirdPartyInvoiceId,
      BillingPeriodOverride: edited.BillingPeriodOverride,
    });

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'BillingPeriod',
          label: 'Computed Billing Period',
          className: 'col-6',
          type: InputTypesEnum.TextReadOnly,
        },
        {
          fieldName: 'BillingPeriodOverride',
          label: 'Billing Period Override (YYYY-MM, empty = remove)',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: SetBillingPeriodWindowDescription.validityCheckerForOverride,
        },
      ],
    },
  ];

  static validityCheckerForOverride(e) {
    if (!e || e.trim() === '') {
      return '';
    }
    // Mirrors PlatformCostSummaryTools.IsValidPeriod — the backend re-validates anyway.
    return /^\d{4}-(0[1-9]|1[0-2])$/.test(e.trim()) ? '' : 'The override must be a valid month in YYYY-MM format.';
  }
}

export default SetBillingPeriodWindowDescription;
